/**
 * Agrupa las validaciones faltantes, indicando la posición (index)
 * y listando los nombres de los campos que fallan en cada elemento de array.
 *
 * @param {object|Array} data   Estructura con los mensajes de error.
 * @returns {object|Array|null} Árbol reducido en el nuevo formato.
 */
export function groupMissingByIndexAndFields(data: any) {
  function walk(node: any): any {
    // 1. -------- Array ----------
    if (Array.isArray(node)) {
      const out: any[] = [];

      node.forEach((item, idx) => {
        const child = walk(item);
        if (child) {
          // Cuando child es un objeto con campos y/o sub-arrays
          out.push({ index: idx, ...child });
        }
      });

      return out.length ? out : null;
    }

    // 2. -------- Objeto ----------
    if (node && typeof node === 'object') {
      // Hoja con mensaje
      if ('message' in node) {
        return node.message ? true : null;
      }

      const fields: string[] = [];           // nombres de hojas fallidas
      const nested: any = {};           // sub-arrays con errores

      for (const [key, value] of Object.entries(node)) {
        const res = walk(value);

        // a) si es true  → el campo (hoja) falla ⇒ agregar a fields
        if (res === true) {
          fields.push(key);
          // b) si es array (errores en array anidado) ⇒ guardar en nested
        } else if (Array.isArray(res)) {
          nested[key] = res;
          // c) si es objeto (no debería ocurrir fuera de arrays) lo ignoramos
        }
      }

      // Construimos objeto de salida sólo si hay algo que reportar
      if (fields.length || Object.keys(nested).length) {
        return Object.assign(
          {},                       // base
          fields.length ? { fields } : {},
          nested                    // posibles sub-arrays
        );
      }
      return null;
    }

    // 3. -------- Primitivo ----------
    return null;
  }

  const result = walk(data);
  
  // Si el resultado es un objeto con fields en la raíz, convertir los fields a booleanos
  if (result && typeof result === 'object' && !Array.isArray(result) && result.fields) {
    const { fields, ...rest } = result;
    const booleanFields: any = {};
    fields.forEach((field: string) => {
      booleanFields[field] = true;
    });
    return { ...booleanFields, ...rest };
  }
  
  return result ?? {};
}